import { render, staticRenderFns } from "./ExpansionRowItem.vue?vue&type=template&id=6a20f09e&scoped=true&lang=pug&"
import script from "./ExpansionRowItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExpansionRowItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExpansionRowItem.vue?vue&type=style&index=0&id=6a20f09e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a20f09e",
  null
  
)

export default component.exports